import { defineComponent as _defineComponent } from 'vue';
import { BPopover } from "bootstrap-vue";
import HelpTerm from "./HelpTerm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HelpPopover',
    props: {
        target: null,
        term: null
    },
    setup(__props) {
        return { __sfc: true, BPopover, HelpTerm };
    }
});
